import api from '../config/api'

export const fetchAllAdvertisement = async () => {
  const res = await api.get("/advertisement/");
  return res.data.data;
};

export const fetchAdvertisementById = async (id) => {
  const res = await api.get(`/advertisement/?id=${id}`);
  return res.data.data;
};

export const fetchAllAdvAttachments = async () => {
  const res = await api.get("/advAttachment/");
  return res.data.data || [];
};

export const createAdvertisement = async(formData) => {
  const res = await api
  .post(`/advertisement/`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
return res.data;
}

export const updateAdvertisement = async (id, formData) => {
  const res = await api
    .post(`/advertisement/?id=${id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  return res.data;
};

export const deleteAdvertisement = async (id) => {
  const res = await api.delete(`/advertisement/?id=${id}`);
  return res.data;
};

export const fetchAdvAttachmentsByAdId = async (id) => {
  const res = await api.get(`/advAttachment/?id=${id}`);
  return res.data.data || [];
};
export const deleteAdvAttachmentById = async (id) => {
  const res = await api.delete(`/advAttachment/?id=${id}`);
  return res.data;
};
